export default "__VITE_ASSET__BbbYVt7Y__"